import { render, staticRenderFns } from "./Expandible.vue?vue&type=template&id=29388587&scoped=true"
import script from "./Expandible.vue?vue&type=script&lang=js"
export * from "./Expandible.vue?vue&type=script&lang=js"
import style0 from "./Expandible.vue?vue&type=style&index=0&id=29388587&prod&lang=sass"
import style1 from "./Expandible.vue?vue&type=style&index=1&id=29388587&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29388587",
  null
  
)

export default component.exports